import React, { Component } from "react";
import {
  DataGrid,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
  Lookup,
  StateStoring,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import {
  criarUsuariosDs,
  criarCpbsDs,
  criarPrefeituraDs,
} from "../../DataSources";
import { Popup, ToolbarItem } from "devextreme-react/popup";
import UserInfo from "../../UserInfo";

export default class UsuariosBox extends Component {
  constructor() {
    super();
    this.state = { verPopupSenha: false, senha: undefined };
    this._gridInstance = React.createRef();
    this.onAtualizandoRow = this.onAtualizandoRow.bind(this);
    this.enviarAcesso = this.enviarAcesso.bind(this);
    console.log(UserInfo.possuiPerfil(["trimap"]));
  }

  onAtualizandoRow(e) {
    e.cancel = true;
    this.props.history.push("/usuarios/editar/" + e.data.id);
  }

  enviarAcesso(e) {
    console.log(e);
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <PaginaToolbar
            titulo="Usuários"
            novoCb={this.novoRegistro.bind(this)}
          >
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={criarUsuariosDs()}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              focusedRowEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
              onEditingStart={this.onAtualizandoRow}
            >
              <FilterRow visible={true} />
              <Editing allowDeleting={false} allowUpdating={true} useIcons={true} />
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                
                caption="Serviços"
                buttons={[
                  "edit",
                  {
                    text: "Mostrar Senha",
                    icon: "key",
                    visible: UserInfo.possuiPerfil(["trimap"]),
                    onClick: (e) => {
                      this.setState({
                        verPopupSenha: true,
                        senha: e.row.data.senha,
                        login: e.row.data.login,
                      });
                    },
                  },
                  {
                    text: "Enviar Acesso",
                    icon: "globe",
                    visible: UserInfo.possuiPerfil(["trimap"]),
                    onClick: (e) => this.enviarAcesso(e),
                  },
                ]}
              />
              <Column
                dataField={"id"}
                caption={"#"}
                allowEditing={false}
                width={80}
                alignment={"center"}
              />
              <Column dataField={"prefeituraId"} caption={"Prefeitura"}>
                <Lookup
                  dataSource={criarPrefeituraDs()}
                  valueExpr={"id"}
                  displayExpr={"nome"}
                />
              </Column>
              <Column dataField={"nome"} caption={"Nome"} />
              <Column dataField={"login"} caption={"Login"} />
              <Column dataField={"cpbsId"} caption={"CPBS"}>
                <Lookup
                  dataSource={criarCpbsDs()}
                  valueExpr={"id"}
                  displayExpr={"contribuinte.nome"}
                />
              </Column>
              <Column dataField={"ativo"} caption={"Ativo"} />
              <Column dataField={"administrador"} caption={"Administrador"} />

              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>
        </div>
        <Popup
          visible={this.state.verPopupSenha}
          onHiding={() =>
            this.setState({ verPopupSenha: false, senha: undefined })
          }
          dragEnabled={false}
          closeOnOutsideClick={false}
          showCloseButton={false}
          showTitle={true}
          width={"400px"}
          height={"300px"}
          title="Senha"
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <h3>Senha do usuário {this.state.login}</h3>
            <p style={{fontSize: "20px"}}>
              <strong>{this.state.senha}</strong>
            </p>
          </div>
          <ToolbarItem
            toolbar={"bottom"}
            widget="dxButton"
            location="center"
            options={{
              text: "Fechar",
              type: "default",
              width: 150,
              onClick: () => {
                this.setState({ verPopupSenha: false, senha: undefined });
              },
            }}
          ></ToolbarItem>
        </Popup>
      </React.Fragment>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    this.props.history.push("/usuarios/novo");
  }
}
